import { useQuery } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';
import { ConsumerCommunicationStatusResponse } from './communicationStatus.types';

const useShowConsumerCommunicationStatus = ({
  causeId,
  token,
}: {
  causeId?: string | null;
  token?: string | null;
}) => {
  const BackerApi = useBackerApi();

  const get = async () => {
    const queryParams = new URLSearchParams();
    if (causeId) queryParams.set('cause_id', causeId);
    if (token) queryParams.set('token', token);

    const { data } = await BackerApi.get<ConsumerCommunicationStatusResponse>(
      `/consumer/communications/status?${queryParams.toString()}`
    );

    return data;
  };

  return useQuery({
    queryKey: [...backerKeys.consumer.communicationStatus.all, causeId, token],
    queryFn: get,
  });
};

export { useShowConsumerCommunicationStatus };
